import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class MenuService {
  public legalEntityMenuEnabled: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
}
